import { loggingout } from "../helpers/loggingOut";
import { errorToaster } from "../helpers/toasterConfiguration";
import store from "../store";
import { setDisabledAccount, setLogout, setSessionEnd } from "../store/slices/errorSlice";

export const handleError = (error) => {
  if (error?.response?.status === 400) {
    error?.response?.data?.errors?.map((error) => {
      errorToaster(error?.message);
    });
  } else if (error?.response?.status === 401) {
    store.dispatch(setSessionEnd(true));
    loggingout();
  } else if (error?.response?.status === 404) {
    window.location.href = "/error";
  } else if (error?.response?.status === 423) {
    store.dispatch(setDisabledAccount(true));
  } else if (error?.response?.status === 428) {
    store.dispatch(setSessionEnd(true));
  } else if (error?.response?.status === 500) {
    errorToaster(error?.response?.data?.errors[0]?.message);
  }
};
